import { graphql } from '@guuru/graphql-common/gql';

export default graphql(`
  mutation ProvideUserEmail(
    $chatId: ID!
    $email: String!
    $isHotTransfer: Boolean
  ) {
    provideUserEmail(
      chatId: $chatId
      email: $email
      isHotTransfer: $isHotTransfer
    ) {
      id
      email
    }
  }
`);
